class Node {
  constructor(data = {}, parent = null, children = []) {
    this.data = data;
    this.parent = parent;
    this.children = children;
  }
}
export default class Tree {
  constructor(array) {
    this.root = new Node({});
    this.createByArray(array);
  }
  createByArray(array, parent, data = [`title`, `url`]) {
    if (!parent) {
      parent = this.root;
    }
    for (let i = 0; i < array.length; i++) {
      const el = array[i];
      if (data.length) {
        el.data = data.reduce((acc, item) => {
          if (item === `url`) {
            el[item] = this._changeRootPath(el[item]);
          }
          return {
            ...acc,
            [item]: el[item]
          };
        }, {});
      }
      const node = new Node(el.data, parent, []);
      parent.children.push(node);

      if (el.children.length) {
        this.createByArray(el.children, node);
      }
      continue;
    }
    return this;
  }
  createByValue(value) {
    const nodeOfCategory = this.findNodeByValue(value) || this.root;
    const parents = this.getParents(nodeOfCategory).reverse();
    return [...parents, nodeOfCategory];
  }
  findNodeByValue(value, key = `url`) {
    let result;
    const arrayOfValues = value.split(`/`);
    for (let j = arrayOfValues.length - 1; j >= 0; j--) {
      const val = arrayOfValues[j];
      const findNodeInArray = (array) => {
        for (let i = 0; i < array.length; i++) {
          if (result) {
            return result;
          }
          const node = array[i];
          if (val === node.data[key].split(`/`).pop()) {
            result = node;
            return node;
          } else {
            findNodeInArray(node.children);
          }
        }
        return result;
      };
      findNodeInArray(this.root.children);
    }
    return result;
  }
  getParents(node) {
    const result = [];
    const getParent = (n) => {
      if (n && n.parent) {
        result.push(n.parent);
        getParent(n.parent);
      } else {
        return result;
      }
      return result;
    };

    return getParent(node);
  }
  simpleFindNodeByValue(value, rootPath, node, key = `url`) {
    const array = node.children;
    const val = value.replace(rootPath, ``);
    let result;
    if (array) {
      for (let i = 0; i < array.length; i++) {
        const nod = array[i];
        if (val === nod.data[key]) {
          result = nod;
          return nod;
        }
      }
    }
    return result;
  }
  updateByValue(value, rootPath, tree) {
    const children = this.simpleFindNodeByValue(
      value,
      rootPath,
      tree[tree.length - 1]
    );
    const parent = this.simpleFindNodeByValue(
      value,
      rootPath,
      tree[tree.length - 2]
    );
    if (children) {
      return [...tree, children];
    } else if (parent) {
      return [...tree.slice(0, -1), parent];
    }
    return this.createByValue(value);
  }
  transformToFlatList(tree) {
    return tree.map((node) => {
      if (node.parent) {
        node.parent.children.forEach((item) => {
          item.data.active = false;
        });
      }
      node.data.active = true;
      return node.children.map((child) => {
        child.data.active = false;
        return child.data;
      });
    });
  }
  _changeRootPath(path) {
    const regExp = new RegExp(`(/store(?=/))|(/store(?=$))`);
    if (regExp.test(path)) {
      return path.replace(/^\/store/, ``);
    }
    return path;
  }
}
